import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent extends ModalDirective {

  @Input() titulo: string = "Título";
  @Input() nomeBotaoConfirmacao: string = "Confirmar";
  @Input() isMostrarBotaoAcao: boolean = false;
  @Output() onClickBotaoAcao = new EventEmitter();

  @ViewChild('modal')
  modal: ModalDirective;

  onSair(event) {
    this.modal.hide();
  }

  onBotaoAcao() {
    this.onClickBotaoAcao.emit();
  }

  show() {
    this.modal.show();
  }

  hide() {
    this.modal.hide();
  }
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/modal/modal.component.ts